import { CATEGORIES_KEYS } from '../../useCategoriesWidget/useCategoriesWidget';
import {
  StyledDescriptionLink,
  StyledHorizontalList
} from '../SelectedCategory.style';
import { useHistory } from 'react-router';
import AppRouter from 'common/AppRouter';

const Link = ({ to, children }) => {
  return (
    <StyledDescriptionLink href={to} target='_blank'>
      {children}
    </StyledDescriptionLink>
  );
};

const InefficiencyPool = ({ isAutomationsEnabled }) => {
  const linkToAutomations = isAutomationsEnabled
    ? {
        to: AppRouter.AUTOMATIONS.path
      }
    : {
        to: 'https://docs.gitstream.cm',
        target: '_blank'
      };

  return (
    <>
      This category refers to the portion of effort currently being wasted due
      to inefficiencies in the development process, such as excessive context
      switching. By improving process efficiency, this pool can be tapped into,
      allowing more effort to be redirected toward creating impact in other
      categories.
      <StyledHorizontalList>
        {/* <li>
          <Link to='#'>Efficiency Playbook</Link>
        </li> */}
        <li>
          <Link to='https://app.linearb.io/performance/Delivery'>
            Track Impact Metrics
          </Link>
        </li>
        <li>
          <Link {...linkToAutomations}>Automations</Link>
        </li>
        <li>
          <Link to='https://app.linearb.io/performance/team-goals-all-teams?globallySelectedTeams=all-teams'>
            Set Team Goals
          </Link>
        </li>
      </StyledHorizontalList>
    </>
  );
};

const KTLO = () => {
  return (
    <>
      This category refers to the essential tasks required to keep the company
      operational on a daily basis while ensuring a stable level of service.
      These tasks might include maintaining current security posture, monitoring
      and troubleshooting services and tickets, and ensuring consistent levels
      of service uptime.
    </>
  );
};

const DeveloperExperience = () => {
  return (
    <>
      This category refers to the investments made to enhance the productivity
      and overall work experience of development teams. Such investments might
      include improving developer tooling, automating testing processes,
      restructuring code, and efforts to reduce the size of the KTLO (Keep the
      Lights On) workload in the future.
    </>
  );
};

const FeatureEnhancements = () => {
  return (
    <>
      This category refers to the strategic investments made to enhance features
      or deliver products that ensure customer satisfaction. Such investments
      might include customer-requested improvements, performance and utilization
      enhancements, iterations aimed at boosting adoption, retention, and
      quality, as well as improvements to product reliability or security.
    </>
  );
};

const NewValue = () => {
  return (
    <>
      This category refers to the strategic investments made to boost revenue
      and growth by attracting new customers or expanding the existing customer
      base. Such investments could include developing new features, integrating
      with new platforms or partner applications, and advancing planned roadmap
      items.
    </>
  );
};

const Others = () => {
  const history = useHistory();
  const goToSettings = () =>
    history.replace(AppRouter.PROJECTS_INVESTMENT_CARVING_CONFIG.path);

  return (
    <>
      The following issues did not meet any category criteria. <br />
      You can improve the classification in{' '}
      <StyledDescriptionLink onClick={goToSettings}>
        Settings
      </StyledDescriptionLink>
    </>
  );
};

export const mapCategoryToDescription = {
  [CATEGORIES_KEYS.KTLO]: KTLO,
  [CATEGORIES_KEYS.DEVELOPER_EXPERIENCE]: DeveloperExperience,
  [CATEGORIES_KEYS.FEATURE_ENHANCEMENTS]: FeatureEnhancements,
  [CATEGORIES_KEYS.NEW_VALUE]: NewValue,
  [CATEGORIES_KEYS.POTENTIAL_SAVINGS]: InefficiencyPool,
  [CATEGORIES_KEYS.OTHERS]: Others
};
